import { Button } from '@fluentui/react-components';
import { ChevronUpRegular, ChevronDownRegular } from '@fluentui/react-icons';
import React from 'react';
import { iconButtonStyles } from '../../../../app/common/styles/CommonStyleObjects';

export interface IListReorderButtons {
  listItemIndex: number;
  totalItemCount: number;
  onSwapUp: (currentItemIndex: number, previousItemIndex: number) => void;
  onSwapDown: (currentItemIndex: number, nextItemIndex: number) => void;
}
export const ListReorderButtons = (props: IListReorderButtons): JSX.Element => {
  const { listItemIndex, totalItemCount, onSwapUp, onSwapDown } = props;
  const orderIconStyles = { marginRight: 10 };
  return (
    <>
      <Button
        appearance="subtle"
        icon={
          <ChevronUpRegular
            color={listItemIndex === 0 ? iconButtonStyles.disabledColor : iconButtonStyles.color}
          />
        }
        style={orderIconStyles}
        title="Move Up"
        disabled={listItemIndex === 0}
        aria-label="Move Up"
        onClick={(): void => {
          onSwapUp(listItemIndex, listItemIndex - 1);
        }}
      />

      <Button
        appearance="subtle"
        icon={
          <ChevronDownRegular
            color={
              listItemIndex === totalItemCount - 1
                ? iconButtonStyles.disabledColor
                : iconButtonStyles.color
            }
          />
        }
        style={orderIconStyles}
        title="Move Down"
        disabled={listItemIndex === totalItemCount - 1}
        aria-label="Move Down"
        onClick={(): void => {
          onSwapDown(listItemIndex, listItemIndex + 1);
        }}
      />
    </>
  );
};
